import { bootstrapApplication } from '@angular/platform-browser';
import { appConfig } from './app/app.config';
import { App } from './app/app';
import { AppConfigService } from './app/core/services/app-config.service';

document.addEventListener('DOMContentLoaded', () => {
  fetch(AppConfigService.configPath)
    .then((response) => response.json())
    .then((jsonData) => {
      sessionStorage.setItem(AppConfigService.configPath, JSON.stringify(jsonData));
      bootstrapApplication(App, appConfig).catch((err) => console.error(err));
    })
    .catch((err) => {
      console.warn('Could not load app config, bootstrapping with defaults');
      console.error(err);
      bootstrapApplication(App, appConfig).catch((e) => console.error(e));
    });
});
